import { CAREER_ID, RACE } from "enefel/career";
import { getRaceFromCareer } from "enefel/race";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Group from "./Group";
type RaceId = (typeof RACE)[keyof typeof RACE];

const Wrapper = styled.div`
  display: inline-flex;
  gap: 0.3em;
  align-items: center;
  font-size: 0.8em;
  opacity: 0.9;
`;

const Name = styled.div`
  white-space: nowrap;
`;

type RaceCareerProps = {
  careerId: CAREER_ID | string;
  raceId?: RaceId | string;
  withGroup?: boolean;
};

const RaceCareer: React.FC<RaceCareerProps> = React.memo(
  ({ careerId, raceId, withGroup = true }) => {
    const { t } = useTranslation("race");
    const race = raceId ? raceId : getRaceFromCareer(careerId as CAREER_ID);

    return (
      <Wrapper>
        {withGroup && <Group race={race as RaceId} />}
        <Name>{t("race:" + race, "__" + race)}</Name>
        <Name>{t("race:" + careerId, "__" + careerId)}</Name>
      </Wrapper>
    );
  }
);

export default RaceCareer;
